const ITEMS_PER_PAGE = 10;

const numberClinicsPage = (
  currentNumberPage: number,
  totalCount: number,
  isFiltersApplied: boolean,
) => {
  if (!totalCount)
    return isFiltersApplied ? "No clinics found with this filter" : "No clinics in this area";

  let start;
  let end;
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
  const endPage = currentNumberPage * ITEMS_PER_PAGE;

  if (currentNumberPage === 1) {
    start = 1;
  } else {
    start = endPage - ITEMS_PER_PAGE + 1;
  }

  if (currentNumberPage !== pageCount) {
    end = endPage;
  } else {
    end = endPage + (totalCount - endPage);
  }

  return `${start}-${end} of ${totalCount} clinics`;
};

export default numberClinicsPage;
